import type { ApiResponseSegcen, ApiResponseSegcenMap } from "@/interfaces/AccessControl";
import type { MESSAGE_ERROR_HTTP } from "@/interfaces/http-client";
import { httpClient } from "@/lib/httpClientAxios";
import { mapToAccessControlUser } from "@/mappings/accessControlUser";
import { getApiUxHeaders, getMessageError } from "@/mappings/httpClient";

const userAccessError: Partial<MESSAGE_ERROR_HTTP> = {
  'default': 'Hubo un error desconocido al obtener los datos del usuario',
  404: "Datos de usuario no encontrado"
};

export const getUserAccess = async (): Promise<ApiResponseSegcenMap | null> => {
  try {
    const { VITE_APP_API_SEGCEM, VITE_APPLICATION_NAME_PDD } = import.meta.env;
    const headers = {...getApiUxHeaders(), 
      nombreAplicacion: VITE_APPLICATION_NAME_PDD
    };
    const {status_code, data} = await httpClient.get<ApiResponseSegcen>(
      `${VITE_APP_API_SEGCEM}/api/aplicaciones/1/0/0/1`,
      { headers },
    );
    if (status_code === 200 && data) {
      return mapToAccessControlUser(data);
    }

    return null;
  } catch (error) {
    throw new Error(getMessageError(error, userAccessError));
  }
};
